import { Insertion } from '@paragon/contract-library';

import { isComponentDesignInsertion } from '../classifiers';
import { getLayoutModelsWithPendingChanges } from '../selectors/changeTracker';
import { LayoutModelsLibraryClientState } from '../store';

export const ROW_ID_LEVEL_SEPARATOR = '.';

export class PathUtilities {
  static createFrom(...modelGuids: string[]) {
    return modelGuids.join(ROW_ID_LEVEL_SEPARATOR);
  }

  static createFromInsertion(insertion: Insertion) {
    return PathUtilities.createFrom(insertion.parentGuid, insertion.objectGuid);
  }

  static createForComponentDesignContainerComponentsCollection(rowPath: string) {
    return `${rowPath}${ROW_ID_LEVEL_SEPARATOR}componentDesignContainer`;
  }

  static getGuids(rowPath: string) {
    return rowPath.split(ROW_ID_LEVEL_SEPARATOR);
  }

  static getGuid(rowPath: string) {
    return PathUtilities.getGuids(rowPath).pop()!;
  }

  static getProjectGuid(rowPath: string) {
    return PathUtilities.getGuids(rowPath)[0];
  }

  static getParentGuid(rowPath: string) {
    const path = PathUtilities.getGuids(rowPath);
    return path[path.length - 2];
  }

  static getParentPath(rowPath: string) {
    return PathUtilities.createFrom(...PathUtilities.getGuids(rowPath).slice(0, -1));
  }

  static *iterateUpAncestors(rowPath: string): IterableIterator<string> {
    const guids = PathUtilities.getGuids(rowPath);
    for (let i = guids.length - 2; i > 0; i -= 1) {
      yield PathUtilities.createFrom(...guids.slice(0, i + 1));
    }
  }

  static isComponentDesign = (state: LayoutModelsLibraryClientState) => (insertion: Insertion) => {
    const layoutModels = getLayoutModelsWithPendingChanges(state);
    return insertion != null && insertion.objectGuid in layoutModels && isComponentDesignInsertion(insertion);
  };

  static isProject(rowPath: string): boolean {
    return PathUtilities.getGuid(rowPath) === PathUtilities.getProjectGuid(rowPath);
  }
}
